<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">HomePage Content</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.stop.prevent="updateHomeContent"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <b-form-group label="Home Page Text 1" label-for="PreLoginHomeText1">
                                                                <b-form-input type="text" id="PreLoginHomeText1"
                                                                    :state="$v.homeContentData.PreLoginHomeText1.$dirty ? !$v.homeContentData.PreLoginHomeText1.$error : null"
                                                                    v-model="homeContentData.PreLoginHomeText1" name="PreLoginHomeText1"
                                                                    autocomplete="PreLoginHomeText1" placeholder="Home Page Text 1">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback>This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>

                                                        </div>
                                                        <div class="col-md-12">

                                                            <b-form-group label="OPT IN Form Text" label-for="OptinText">
                                                                <b-form-input type="text" id="OptinText"
                                                                    :state="$v.homeContentData.OptinText.$dirty ? !$v.homeContentData.OptinText.$error : null"
                                                                    v-model="homeContentData.OptinText" name="OptinText"
                                                                    autocomplete="OptinText" placeholder="OPT IN Form Text">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <b-form-group label="Home Page Video" label-for="PreLoginHomeVideo1">
                                                                <b-form-input type="url" id="PreLoginHomeVideo1"
                                                                    v-model="homeContentData.PreLoginHomeVideo1"
                                                                    :state="$v.homeContentData.PreLoginHomeVideo1.$dirty ? !$v.homeContentData.PreLoginHomeVideo1.$error : null"
                                                                    name="PreLoginHomeVideo1" autocomplete="PreLoginHomeVideo1"
                                                                    placeholder="Link of Home Page Video">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>


                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeHeader1" class="d-block">Home Page Header
                                                                    1</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeHeader1"
                                                                        v-model="homeContentData.PreLoginHomeHeader1" :config="editorConfig"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeHeader1.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeHeader2" class="d-block">Home Page Header
                                                                    2</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeHeader2"
                                                                        v-model="homeContentData.PreLoginHomeHeader2" :config="editorConfig1"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeHeader2.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeHeader3" class="d-block">Home Page Header
                                                                    3</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeHeader3"
                                                                        v-model="homeContentData.PreLoginHomeHeader3" :config="editorConfig2"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeHeader3.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeHeader4" class="d-block">Home Page Header
                                                                    4</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeHeader4"
                                                                        v-model="homeContentData.PreLoginHomeHeader4" :config="editorConfig3"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeHeader4.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <b-form-group label="Home Page Text 2" label-for="PreLoginHomeText2">
                                                                <b-form-input type="text" id="PreLoginHomeText2"
                                                                    v-model="homeContentData.PreLoginHomeText2" name="PreLoginHomeText2"
                                                                    :state="$v.homeContentData.PreLoginHomeText2.$dirty ? !$v.homeContentData.PreLoginHomeText2.$error : null"
                                                                    autocomplete="PreLoginHomeText2" placeholder="Home Page Text 2">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeText3" class="d-block">Home Page Text 3</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeText3"
                                                                        v-model="homeContentData.PreLoginHomeText3" :config="editorConfig4"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeText3.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeText4" class="d-block">Home Page Text 4</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeText4"
                                                                        v-model="homeContentData.PreLoginHomeText4" :config="editorConfig5"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeText4.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeText5" class="d-block">Home Page Text 5</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeText5"
                                                                        v-model="homeContentData.PreLoginHomeText5" :config="editorConfig6"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeText5.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginHomeText6" class="d-block">Home Page Text 6</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginHomeText6"
                                                                        v-model="homeContentData.PreLoginHomeText6" :config="editorConfig7"
                                                                        >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginHomeText6.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <b-form-group
                                                                label="Home Page Image uploading Path (Image will be save in the dctrainings3/dctwebsite)"
                                                                label-for="uploadingPath">
                                                                <b-form-input type="text" id="uploadingPath"
                                                                    v-model="contentConfig.uploadingPath" name="uploadingPath"
                                                                    :state="$v.contentConfig.uploadingPath.$dirty ? !$v.contentConfig.uploadingPath.$error : null"
                                                                    placeholder="Home Page Image uploading Path (Image will be save in the dctrainings3/dctwebsite)">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 1"
                                                                        label-for="PreLoginHomeImage1">

                                                                        <b-form-file id="PreLoginHomeImage1"
                                                                            v-model="contentImages.PreLoginHomeImage1"
                                                                            name="PreLoginHomeImage1" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">

                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginHomeImage1}`"
                                                                        class=" img-fluid" alt="">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 2"
                                                                        label-for="PreLoginHomeImage2">

                                                                        <b-form-file id="PreLoginHomeImage2"
                                                                            v-model="contentImages.PreLoginHomeImage2"
                                                                            name="PreLoginHomeImage2" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginHomeImage2}`"
                                                                        class=" img-fluid" alt="">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 3"
                                                                        label-for="PreLoginHomeImage3">

                                                                        <b-form-file id="PreLoginHomeImage3"
                                                                            v-model="contentImages.PreLoginHomeImage3"
                                                                            name="PreLoginHomeImage3" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">

                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginHomeImage3}`"
                                                                        class=" img-fluid" alt="">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 4"
                                                                        label-for="PreLoginHomeImage4">
                                                                        <b-form-file id="PreLoginHomeImage4"
                                                                            v-model="contentImages.PreLoginHomeImage4"
                                                                            name="PreLoginHomeImage4" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image"
                                                                            :state="!contentImages.PreLoginHomeImage4">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginHomeImage4}`"
                                                                        class=" img-fluid" alt="">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
    name: "home_page_content",
    mixins: [validationMixin],
    data() {
        return {
            contentImages: {
                PreLoginHomeImage1: [],
                PreLoginHomeImage2: [],
                PreLoginHomeImage3: [],
                PreLoginHomeImage4: [],
            },
            contentConfig: {
                uploadingPath: "images/Content Images/Home Page"
            },
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },
            editorConfig2: { 
                versionCheck: false 
            },
            editorConfig3: { 
                versionCheck: false 
            },
            editorConfig4: { 
                versionCheck: false 
            },
            editorConfig5: { 
                versionCheck: false 
            },
            editorConfig6: { 
                versionCheck: false 
            },
            editorConfig7: { 
                versionCheck: false 
            },
            homeContentData: {
                PreLoginHomeText1: "",
                OptinText: "",
                PreLoginHomeVideo1: "",
                PreLoginHomeHeader1: "",
                PreLoginHomeHeader2: "",
                PreLoginHomeHeader3: "",
                PreLoginHomeHeader4: "",
                PreLoginHomeText2: "",
                PreLoginHomeText3: "",
                PreLoginHomeText4: "",
                PreLoginHomeText5: "",
                PreLoginHomeText6: "",
                PreLoginHomeImage1: '',
                PreLoginHomeImage2: '',
                PreLoginHomeImage3: '',
                PreLoginHomeImage4: '',
            },
        }
    },
    validations: {
        homeContentData: {
            PreLoginHomeText1: {
                required
            },
            OptinText: {
                required
            },
            PreLoginHomeVideo1: {
                required
            },
            PreLoginHomeHeader1: {
                required
            },
            PreLoginHomeHeader2: {
                required
            },
            PreLoginHomeHeader3: {
                required
            },
            PreLoginHomeHeader4: {
                required
            },
            PreLoginHomeText2: {
                required
            },
            PreLoginHomeText3: {
                required
            },
            PreLoginHomeText4: {
                required
            },
            PreLoginHomeText5: {
                required
            },
            PreLoginHomeText6: {
                required
            },
        },
        contentConfig: {
            uploadingPath: {
                required
            },
        },
    },
    methods: {
        updateHomeContent() {
            this.$v.homeContentData.$touch();
            this.$v.contentConfig.$touch();
            if (this.$v.homeContentData.$anyError || this.$v.contentConfig.$anyError) {
                return;
            }
            API.updateHomeContent({ ...this.homeContentData, ...this.contentConfig, ...this.contentImages }, this.updateHomeContentCB, this.errorCB)
        },
        updateHomeContentCB(res) {
            this.homeContentData = res.data;
            this.$showNotification({ message: "Updated Successfully" }, 'success')

        },
        getWebContent() {
            API.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.homeContentData = res.data;
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getWebContent();
    },
    components: {}
}
</script>
